import type { FunctionComponent, HTMLProps } from 'react'
import React from 'react'

import classnames from 'classnames'

import { TypographyV2 } from '../../Seatbelt2/Foundations/Typography'
import styles from './ImageCredit.module.scss'

export const ImageCredit: FunctionComponent<Props> = ({
  credit,
  className,
  ...rest
}) => (
  <TypographyV2
    tag="span"
    textStyle="sb-text-interface-body-x-small-regular"
    data-testid="image-credit"
    className={classnames(
      'sb-bg-color-text-white',
      styles.imageCredit,
      className
    )}
    {...rest}
  >
    {credit}
  </TypographyV2>
)

///////// IMPLEMENTATION /////////

type Props = {
  /**
   * Image credit text to be displayed (will always be converted to upper case)
   */
  credit: string
  /**
   * Class Name to be added to the component to add additional styling/positioning
   */
  className?: string
} & HTMLProps<HTMLSpanElement>
